"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGoogleFontMap = exports.useGoogleFonts = void 0;
var inversify_react_1 = require("inversify-react");
var immutable_1 = __importDefault(require("swr/immutable"));
var zod_1 = require("zod");
var fuse_js_1 = __importDefault(require("fuse.js"));
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
function useGoogleFonts() {
    var googleFontsApiKey = (0, inversify_react_1.useInjection)("googleFontsApiKey");
    var url = new URL("https://www.googleapis.com/webfonts/v1/webfonts");
    url.searchParams.append("key", googleFontsApiKey);
    url.searchParams.append("sort", "popularity");
    var data = (0, immutable_1.default)(url.toString(), function (arg) { return fetchFonts(arg); }, { onError: function (err) { return console.error(err); } }).data;
    return data;
}
exports.useGoogleFonts = useGoogleFonts;
function fetchFonts(url) {
    return __awaiter(this, void 0, Promise, function () {
        var response, responseData, validatedData, filteredFonts, iFonts, fuse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetch(url)];
                case 1:
                    response = _a.sent();
                    if (response.status !== 200) {
                        throw new Error("Google fonts API returned an error code: ".concat(response.status));
                    }
                    return [4, response.json()];
                case 2:
                    responseData = _a.sent();
                    validatedData = itemsArraySchema.parse(responseData.items);
                    filteredFonts = validatedData.filter(function (_a) {
                        var subsets = _a.subsets, variants = _a.variants;
                        return subsets.includes("latin") && variants.includes("regular");
                    });
                    iFonts = transformToIFonts(filteredFonts);
                    fuse = new fuse_js_1.default(iFonts, { keys: ["friendlyName"], threshold: 0.3 });
                    return [2, { fuse: fuse, iFonts: iFonts, fonts: filteredFonts }];
            }
        });
    });
}
function useGoogleFontMap() {
    var data = useGoogleFonts();
    if (!data)
        return undefined;
    return new Map(data.fonts.map(function (f) { return [f.family, f]; }));
}
exports.useGoogleFontMap = useGoogleFontMap;
function transformToIFonts(items) {
    return items.map(function (_a) {
        var family = _a.family, category = _a.category;
        return {
            vendor: commonTypes_1.FontVendor.Google,
            friendlyName: family,
            name: family,
            typeface: toTypeface(category),
        };
    });
}
function toTypeface(category) {
    switch (category.toLowerCase()) {
        case "serif":
            return commonTypes_1.FontTypeface.Serif;
        case "sans-serif":
            return commonTypes_1.FontTypeface.SansSerif;
        case "monospace":
            return commonTypes_1.FontTypeface.Monospace;
        default:
            return commonTypes_1.FontTypeface.SansSerif;
    }
}
var itemSchema = zod_1.z.object({
    category: zod_1.z.string(),
    family: zod_1.z.string(),
    files: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
    subsets: zod_1.z.array(zod_1.z.string()),
    variants: zod_1.z.array(zod_1.z.string()),
});
var itemsArraySchema = zod_1.z.array(itemSchema);
